<ng-container *sbPageAction>

  <a *ngPermissions="permissionService.Permission.location_edit" [pathParams]="[{id: 'locationID', value: location?.id}]"
     [queryParams]="{returnTo: this.util.getPageLink()}" [sbRouterLink]="util.RoutingID.locationEdit"
     class="btn btn-primary">
    <sb-icon class="mr-1" icon="edit"></sb-icon>
    {{ 'lang.globals.editLocation' | translate }}
  </a>
</ng-container>

<div [style.background-image]="
    isPmgClient ?
    ('url(./assets/img/' + (getParentCust() ? getParentCust() + '-outside.jpg)': 'location-placeholder-bg.jpg)'))
    :
    ('url(' + headerUrl + ')')"
     class="d-flex flex-row-fluid w-100 header-wrapper"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div (click)="pickHeader()" *ngPermissions="permissionService.Permission.location_edit"
       class="userPicEdit userPicEditFar cursor-pointer">
    <sb-icon class="icon-center" icon="edit"></sb-icon>
  </div>
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100">
    <sb-card>
      <div card-body style="width: 700px">
        <div class="d-flex justify-content-between text-start">
          <div style="position: absolute;top: -67px;display: flex;">
            <ng-container *ngIf="isPmgClient; else uploadable">
              <div class="image-video-wrapper">
                <div class="justify-content-center align-items-center d-flex" style="width: 100px; height: 100px;">
                  <img *ngIf="getParentCust()" alt="{{getParentCust()}}" src="./assets/img/{{getParentCust()}}.png"
                       style="width: 100px;" />
                  <sb-icon *ngIf="!getParentCust()" icon="questionmark"></sb-icon>
                </div>
              </div>
            </ng-container>
            <ng-template #uploadable>
              <div class="image-video-wrapper">
                <ng-container *ngIf="permissionService.hasPermission(permissionService.Permission.location_edit); else noLocationEdit">
                  <div (click)="pickLogo()" [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''"
                       class="userPic cursor-pointer">
                    <div class="userPicEdit">
                      <sb-icon class="icon-center" icon="edit"></sb-icon>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noLocationEdit>
                  <div [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''" class="userPic">
                  </div>
                </ng-template>
              </div>

            </ng-template>

            <div class="ml-4">
              <h2 class="font-weight-bolder" style="color: #fdfeff;text-shadow: 0 0 10px #000;">
                {{ location?.name ? location?.name : location?.identifier }}</h2>
              <div class="d-flex align-items-center">
                <h6 class="d-flex align-items-center"
                    style="color: #fdfeff;text-shadow: 0 0 5px #000;">{{ 'lang.globals.locationID:' | translate }}
                  {{ location?.id }}
                </h6>
                <div *ngPermissions="permissionService.Permission.tag_list" class="d-flex align-items-center">
                  <sb-tags [dtoId]="location?.id" [dtoType]="tagService.TaggableDTO.Location" [tags]="location?.tags"
                           class="ml-2"></sb-tags>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-row" style="padding-left: 10rem">
            <div class="d-flex align-items-center pr-4 border-dashed-right">
              <button class="btn white grey-bg" container="body" ngbTooltip="{{'lang.globals.locationstatus'|translate}}"
                      placement="top"
                      style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)">
                <sb-icon icon="locationStreet"></sb-icon>
                {{ 'lang.globals.nA' | translate }}
              </button>
            </div>
            <div class="d-flex align-items-center px-4">
              <button class="btn {{onlineStatusColor()+'-bg'}}" container="body"
                      ngbTooltip="{{'lang.globals.playerStatus'|translate}}" placement="top"
                      style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)">
                <sb-icon icon="playerOnline"></sb-icon>
                {{ onlineStatusText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>


<div class="px-0 px-sm-0 px-md-2 px-lg-4 px-xl-5 px-xxl-10 px-xxxl-10" style="margin-top: -100px">
  <div class="row">
    <div *ngIf="location?.countDevices" class="col">
      <sb-card [wave]="true" classes="overflow-hidden" waveColor="#1dc9b7">
        <div card-fit>
          <div class="d-flex align-items-center p-5">
            <div class="mr-3">
              <sb-icon *ngIf="animateState===0" [animationOptions]="animationOptions" class="mr-3"
                       icon="playerOnlineAnimation"
                       style="font-size: 3rem"></sb-icon>
              <sb-icon *ngIf="animateState!==0" class="mr-3" icon="playerOnline" style="font-size: 3rem"></sb-icon>
            </div>
            <div class="d-flex flex-column">
              <h1>{{ location?.countDevices ?? 0 }}</h1>
              <h5 class="text-dark-50">{{ 'lang.globals.devices' | translate }}</h5>
            </div>
          </div>
        </div>
      </sb-card>
    </div>
    <div *ngIf="visitorTracker?.length >0" class="col">
      <sb-card [wave]="true" classes="overflow-hidden" waveColor="#ddd">
        <div card-fit>
          <div class="d-flex align-items-center p-5">
            <div class="mr-3">
              <sb-icon *ngIf="animateState===1" [animationOptions]="animationOptions" class="mr-3"
                       icon="trackerAnimation"
                       style="font-size: 3rem"></sb-icon>
              <sb-icon *ngIf="animateState!==1" class="mr-3" icon="tracker" style="font-size: 3rem"></sb-icon>
            </div>
            <div class="d-flex flex-column">
              <h1>{{ visitorTracker ? visitorTracker.length : 0 }}</h1>
              <h5>{{ 'lang.globals.tracker' | translate }}</h5>
            </div>
          </div>
        </div>
      </sb-card>
    </div>
  </div>
  <!--  <div class="row" *ngIf="isPmgClient || isReemtsmaClient">
      <div class="col-3">
        <sb-card classes="overflow-hidden" [wave]="true" waveColor="#ddd">
          <div card-fit>
            <div class="d-flex align-items-center p-5">
              <div class="mr-3">
                <fa-icon style="font-size: 3rem" class="mr-3" icon="percent"></fa-icon>
              </div>
              <div class="d-flex flex-column">
                <h1>34</h1>
                <h5>{{'lang.locationDetails.advertisingEffectivenessRate' | translate}}</h5>
              </div>
            </div>
          </div>
        </sb-card>
      </div>
      <div class="col-3">
        <sb-card classes="overflow-hidden" [wave]="true" waveColor="#e0b352b8">
          <div card-fit>
            <div class="d-flex align-items-center p-5">
              <div class="mr-3">
                <fa-icon style="font-size: 3rem" class="mr-3" icon="cookie-bite"></fa-icon>
              </div>
              <div class="d-flex flex-column">
                <h1>89</h1>
                <h5 class="text-dark-50">{{'lang.locationDetails.productsSoldToday' | translate}}</h5>
              </div>
            </div>
          </div>
        </sb-card>
      </div>
      <div class="col-3">
        <sb-card classes="overflow-hidden" [wave]="true" waveColor="#3F83B9">
          <div card-fit>
            <div class="d-flex align-items-center p-5">
              <div class="mr-3">
                <fa-icon style="font-size: 3rem" class="mr-3" icon="running"></fa-icon>
              </div>
              <div class="d-flex flex-column">
  &lt;!&ndash;              <h1>{{locationReporting?.buckets[0]?.frames[0]?.data?.unique}}</h1>&ndash;&gt;
                <h1>0</h1>
                <h5 class="text-dark-50">{{'lang.locationDetails.visitorsToday' | translate}}</h5>
              </div>
            </div>
          </div>
        </sb-card>
      </div>
      <div class="col-3">
        <sb-card classes="overflow-hidden" [wave]="true" waveColor="#1dc9b7">
          <div card-fit>
            <div class="d-flex align-items-center p-5">
              <div class="mr-3">
                <sb-icon style="font-size: 3rem" class="mr-3" icon="playerOnline"></sb-icon>
              </div>
              <div class="d-flex flex-column">
                <h1>{{countDevices()}}</h1>
                <h5 class="text-dark-50">{{'lang.globals.devices' | translate}}</h5>
              </div>
            </div>
          </div>
        </sb-card>
      </div>
    </div>-->

  <div class="row">
    <div class="col-lg-3">
      <sb-card>
        <div card-body>
          <ul class="nav-tabs nav sidenav">
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsOverview" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsOverview"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="eye"></sb-icon>
                {{ 'lang.globals.overview' | translate }}
                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.location_visitor_aggregation" class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsStatisticsVisitor" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsStatisticsVisitor"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="pieChart"></sb-icon>
                {{ 'lang.globals.visitorStatistic' | translate }}
                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.location_devices_show" class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsDevices" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsDevices"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="playerOnline"></sb-icon>
                {{ 'lang.globals.devices' | translate }}
                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.visitor_tracker_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsTracker" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsTracker"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="tracker"></sb-icon>
                {{ 'lang.globals.tracker' | translate }}
                </span></a>
            </li>

            <!-- && location?.countVisitorTracker > 0" -->
            <li *ngIf="permissionService.hasPermission(permissionService.Permission.visitor_tracker_list)"
                class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsTrackerAssignment" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsTrackerAssignment"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="tracker"></sb-icon>
                {{ 'lang.globals.trackerAssignment' | translate }}
                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.location_attributes_show" class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsSettings" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsSettings"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="attributes"></sb-icon>
                {{ 'lang.globals.attributes' | translate }}
                </span></a>
            </li>
            <li *ngIf="isPmgClient" class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsViews" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsViews"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="management"></sb-icon>
                {{ 'lang.globals.views' | translate }}
                </span></a>
            </li>
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsThreeDimensionalView" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsThreeDimensionalView"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="cube"></sb-icon>
                {{ 'lang.locationDetails.3D_view' | translate }}
                </span></a>
            </li>
            <!--
            <li *ngPermissions="[permissionService.Permission.attachment_list, permissionService.Permission.attachment_attach_to_location]"
                class="nav-item">
              <a [isLinkActive]="util.RoutingID.locationDetailsAttachments" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.locationDetailsAttachments"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="attachments"></sb-icon>
                {{'lang.globals.attachments' | translate}}
                </span></a>
            </li>
            -->
          </ul>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
